function BtnPrimary({
  text,
  onClick,
  type,
  isDisabled,
  icon,
  url,
  download,
  target,
  ...props
}) {
  return (
    <a
      download={download}
      href={url}
      id="btn-primary"
      type={type}
      onClick={onClick}
      className={` text-white bg-primary hover:bg-primary-hover transition-all rounded-16 active:bg-primary-active focus:outline-none font-normal text-base rounded-card ${props.className}`}
      disabled={isDisabled}
      target={target}
    >
      {icon && <img className="inline ml-2" src={icon} />} {text}
    </a>
  );
}

export { BtnPrimary };

function BtnAlternative({
  text,
  onClick,
  icon,
  url,
  download,
  isDisabled,
  ...props
}) {
  return (
    <a
      download={download}
      href={url}
      id="btn-alternative"
      type="button"
      // disabled={true}
      onClick={onClick}
      className={`${
        props.className
      } flex items-center bg-transparent  hover:bg-shade active:bg-shadeStrong transition-all focus:outline-none font-normal text-base rounded-card ${
        isDisabled && "pointer-events-none cursor-not-allowed"
      }`}
    >
      {icon && <img className="inline ml-2" src={icon} />} {text}
    </a>
  );
}

export { BtnAlternative };
